import { itx } from "../../translationItx/itx";
import { SequenceStep, enumActions } from "../Guide";
import { ToDoItem } from "../ToDoItem";
import guideSequence_addRoom from "./guideSequence_addRoom";
import openRoomOrFloorSequence from "./multibleSequencesHelp";

// ContextMenuLables.addFloors
function sequence(type: string, lastToDoItem?: ToDoItem): Array<SequenceStep> {
  let firstRoom = state.floors?.sortBy("Tag")[0]?.rooms.sortBy("Tag")[0];
  return [
    {
      action: enumActions.call,
      subSequence: () => {
        if (state.allRooms().length == 0) {
          return [
            {
              action: enumActions.explain,
              text: `das Projekt hat noch keinen Raum,
              also muss ich zunächst noch einen Raum anlegen`,
            },
            ...guideSequence_addRoom(""),
            { action: enumActions.wait },
          ];
        } else {
          return undefined;
        }
      },
    },
    {
      action: enumActions.function,
      func: async (): Promise<void> => {
        state.selectionManager.selectedObject = state.allRooms()[0];
      },
    },
    {
      action: enumActions.wait,
    },
    {
      action: enumActions.call,
      subSequence: () => {
        const page = state.objectRegistry.getObject(state.activePaneId);

        if (page?.parent?.className == "Room") {
          return [];
        } else {
          if (!firstRoom) {
            firstRoom = state.floors?.sortBy("Tag")[0]?.rooms.sortBy("Tag")[0];
          }
          return [...openRoomOrFloorSequence({ roomGiven: firstRoom })];
        }
      },
    },

    {
      action: enumActions.wait, // wait until page is open
    },

    // findet das letzte nicht muss noch verbessert werden
    {
      id: ["menuBarWrapper", "menuBar", `menuGroup_background`, "menuButton_submittals", "bgRoomSubmittals"], // no itx
      action: enumActions.click,
    },
    {
      action: enumActions.wait, // wait until dialog is open
    },
    {
      id: `backgroundPicture_Frame 1.png_click`,
      action: enumActions.click,
    },
    // needs to be two times because of time delay of ok button
    {
      action: enumActions.wait, // wait until pictue is loaded is open
    },
    {
      action: enumActions.wait, // wait until pictue is loaded is open
    },
    {
      id: `BaseDialog_ok`,
      action: enumActions.click,
    },
  ];
}

export default sequence;
